<template>
  <div class="page-about">
    <!-- 核心理念 -->
    <SRF>
      <Core type="about" />
    </SRF>
    <!-- 介绍 -->
    <SRF>
      <CompanyInfo />
    </SRF>
    <!-- 横幅 -->
    <SRF>
      <Banner ref="bannerRef" :bannerShow="bannerShow" />
    </SRF>
    <!-- 公司荣誉 -->
    <SRF>
      <Honor :list="topList" />
    </SRF>
    <!-- 证书轮播 -->
    <SRF>
      <HonorSwiper :list="bottomList" />
    </SRF>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import utils from "@/api/Utils";
import Core from "../Home/components/Core";
import CompanyInfo from "./components/CompanyInfo";
import Banner from "./components/Banner";
import Honor from "./components/Honor";
import HonorSwiper from "./components/HonorSwiper";
import Footer from "@/components/MobileIframe/components/Footer";
import { pageApi } from "@/api";
export default {
  components: {
    Core,
    CompanyInfo,
    Banner,
    Honor,
    HonorSwiper,
    Footer,
  },
  data() {
    return {
      bannerShow: false,
      topList: [],
      bottomList: [],
    };
  },

  created() {
    // console.log(this.$publicData)
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            console.log("entries", entries);
            entries.forEach((entry) => {
              this.bannerShow = true;
            });
          },
          {
            root: null, // 相对于视口
            threshold: 0.5, // 当 50% 的元素进入视口时触发
          }
        );
        // 监听组件根元素
        observer.observe(this.$refs.bannerRef.$el);
      }, 1500);
    });
    this.getHonorList();
  },
  methods: {
    getHonorList() {
      pageApi.getHonorList().then((res) => {
        this.topList = res.result.arr_top;
        this.bottomList = _.chunk(res.result.arr_bottom, 4);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("./index.scss");
</style>
